export enum BannersEnum {
    MAX_LISCENSE = 'MAX_LISCENSE',
}
